import {ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot, UrlTree} from "@angular/router";
import {AuthGuardData, createAuthGuard} from "keycloak-angular";

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData): Promise<boolean | UrlTree> => {
  const {authenticated, grantedRoles, keycloak} = authData;
  if (!authenticated) {
    console.warn("User was not authenticated. Redirecting to Keyclaok for authentication.");
    // Use was not authenticated
    await keycloak.login({redirectUri: window.location.href});
    return false;
  }
  return true;
};
export const checkLoginGuard = createAuthGuard<CanActivateFn|CanActivateChildFn>(isAccessAllowed);
